(function () {
  function initZoom() {
    const images = document.querySelectorAll('.custom-main-product-media-img');
    if (!images.length) return;

    images.forEach((img) => {
      let scale = 1;
      let lastScale = 1;
      let translateX = 0;
      let translateY = 0;
      let originX = 0;
      let originY = 0;
      let lastTap = 0;
      let isPinching = false;
      let initialDistance = 0;
      let lastTouchX = 0;
      let lastTouchY = 0;

      // Ensure container clips the image
      img.parentElement.style.overflow = 'hidden';
      img.style.transformOrigin = 'center center';
      img.style.transition = '';

      function clampTranslate(tx, ty) {
        if (scale <= 1) return { x: 0, y: 0 };
        const rect = img.getBoundingClientRect();
        const maxX = (rect.width * (scale - 1)) / 2;
        const maxY = (rect.height * (scale - 1)) / 2;
        return {
          x: Math.min(Math.max(tx, -maxX), maxX),
          y: Math.min(Math.max(ty, -maxY), maxY),
        };
      }

      function applyTransform(animated) {
        if (animated) img.style.transition = 'transform 0.3s ease';
        const clamped = clampTranslate(translateX, translateY);
        translateX = clamped.x;
        translateY = clamped.y;
        img.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
        if (animated) setTimeout(() => img.style.transition = '', 300);
      }

      function resetZoom(animated = true) {
        scale = 1;
        translateX = 0;
        translateY = 0;
        lastScale = 1;
        isPinching = false;
        if (animated) img.style.transition = 'transform 0.3s ease';
        img.style.transform = 'translate(0px, 0px) scale(1)';
        if (animated) setTimeout(() => img.style.transition = '', 300);
      }

      function getDistance(touches) {
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      // Double-tap to toggle zoom
      img.addEventListener('touchend', (e) => {
        if (isPinching) { isPinching = false; return; }
        const now = Date.now();
        if (now - lastTap < 300) {
          e.preventDefault();
          if (scale > 1) {
            resetZoom();
          } else {
            scale = 2.5;
            translateX = 0;
            translateY = 0;
            applyTransform(true);
          }
        }
        lastTap = now;
      });

      // Pinch start
      img.addEventListener('touchstart', (e) => {
        if (e.touches.length === 2) {
          isPinching = true;
          e.preventDefault();
          initialDistance = getDistance(e.touches);
          lastScale = scale;
        } else if (e.touches.length === 1 && scale > 1) {
          lastTouchX = e.touches[0].clientX;
          lastTouchY = e.touches[0].clientY;
        }
      }, { passive: false });

      // Pinch move + pan
      img.addEventListener('touchmove', (e) => {
        e.preventDefault();
        if (e.touches.length === 2 && isPinching) {
          const newDist = getDistance(e.touches);
          scale = Math.min(Math.max(lastScale * (newDist / initialDistance), 1), 4);
          requestAnimationFrame(() => applyTransform(false));
        } else if (e.touches.length === 1 && scale > 1) {
          const dx = e.touches[0].clientX - lastTouchX;
          const dy = e.touches[0].clientY - lastTouchY;
          translateX += dx;
          translateY += dy;
          lastTouchX = e.touches[0].clientX;
          lastTouchY = e.touches[0].clientY;
          requestAnimationFrame(() => applyTransform(false));
        }
      }, { passive: false });

      // Reset on pinch end if scale near 1
      img.addEventListener('touchend', (e) => {
        if (scale < 1.1) resetZoom();
      });
    });

    // Reset ALL images when swiper changes slide
    const swiper = document.querySelector('.custom-main-product-media-swiper');
    if (swiper) {
      swiper.addEventListener('touchstart', () => {
        document.querySelectorAll('.custom-main-product-media-img').forEach(img => {
          img.style.transition = 'transform 0.2s ease';
          img.style.transform = 'translate(0,0) scale(1)';
          setTimeout(() => img.style.transition = '', 200);
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZoom);
  } else {
    initZoom();
  }
})();
// Desktop: scroll-to-zoom + click-drag-to-pan
(function() {
  document.querySelectorAll('.custom-main-product-media-img').forEach((img) => {
    let scale = 1;
    let translateX = 0;
    let translateY = 0;
    let isDragging = false;
    let startX = 0;
    let startY = 0;

    img.parentElement.style.overflow = 'hidden';
    img.style.transformOrigin = 'center center';
    img.style.userSelect = 'none';
    img.draggable = false;

    function clamp(tx, ty) {
      if (scale <= 1) return { x: 0, y: 0 };
      const maxX = (img.offsetWidth * (scale - 1)) / 2;
      const maxY = (img.offsetHeight * (scale - 1)) / 2;
      return {
        x: Math.min(Math.max(tx, -maxX), maxX),
        y: Math.min(Math.max(ty, -maxY), maxY),
      };
    }

    function draw(animated) {
      const c = clamp(translateX, translateY);
      translateX = c.x; translateY = c.y;
      img.style.transition = animated ? 'transform 0.25s ease' : 'none';
      img.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
    }

    function reset() {
      scale = 1; translateX = 0; translateY = 0;
      draw(true);
      img.style.cursor = 'zoom-in';
    }

    // Scroll to zoom
    img.addEventListener('wheel', (e) => {
      e.preventDefault();
      e.stopPropagation();
      scale = Math.min(Math.max(scale + (e.deltaY > 0 ? -0.25 : 0.25), 1), 4);
      if (scale <= 1) { reset(); return; }
      img.style.cursor = 'zoom-out';
      draw(false);
    }, { passive: false });

    // Double-click to toggle
    img.addEventListener('dblclick', (e) => {
      e.preventDefault();
      if (scale > 1) { reset(); return; }
      scale = 2.5; translateX = 0; translateY = 0;
      img.style.cursor = 'zoom-out';
      draw(true);
    });

    // Pointer capture for reliable drag
    img.addEventListener('pointerdown', (e) => {
      if (scale <= 1) return;
      e.preventDefault();
      img.setPointerCapture(e.pointerId);
      isDragging = true;
      startX = e.clientX - translateX;
      startY = e.clientY - translateY;
      img.style.cursor = 'grabbing';
      img.style.transition = 'none';
    });

    img.addEventListener('pointermove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      translateX = e.clientX - startX;
      translateY = e.clientY - startY;
      requestAnimationFrame(() => draw(false));
    });

    img.addEventListener('pointerup', () => {
      if (!isDragging) return;
      isDragging = false;
      img.style.cursor = scale > 1 ? 'zoom-out' : 'zoom-in';
    });
  });
})();
